import '@/styles/app.sass'

import Vue from 'vue'
import App from './App.vue'
import router from '@/utils/router'
import vuetify from '@/utils/vuetify'
import axios from '@/utils/ajax/http'

import { Stripe, loadStripe } from '@stripe/stripe-js'
import mixpanel from 'mixpanel-browser'
import { getImgSrc, initSentry, errorAlert, alert } from './utils/helperFunctions'
import { createPinia, PiniaVuePlugin } from 'pinia'

Vue.use(PiniaVuePlugin)
export const pinia = createPinia()

export const app = new Vue({ router, pinia, vuetify, render: (h) => h(App) })

// // sentry
// if (import.meta.env.VITE_NODE_ENV !== 'development') {
//   initSentry()
// }

Vue.prototype.$http = axios
Vue.prototype.$img = getImgSrc
Vue.prototype.$errorAlert = errorAlert
Vue.prototype.$alert = alert

export let stripe: Stripe

async function init() {
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
  stripe = await loadStripe(key)
  Vue.prototype.$stripe = stripe

  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    // debug: process.env.NODE_ENV !== 'production',
    // eslint-disable-next-line
    api_host: 'https://api.mixpanel.com',
  })

  app.$mount('#app')
}

init()
